import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IFitTablePinPadFormMeta {
    pinPadDigit: FormInputMeta;
    encryptionCondition: FormInputMeta;

}

const fitTablePinPadFormMeta = {} as IFitTablePinPadFormMeta;

fitTablePinPadFormMeta.pinPadDigit = {
    name: "pinPadDigit",
    type: "text",
    label: "PIN Pad Digit",
    placeholder: "",
    validation: yup.string()
};

fitTablePinPadFormMeta.encryptionCondition = {
    name: "encryptionCondition",
    type: "select",
    label: "Condition Encryption",
    placeholder: "",
    validation: yup.string()
};


export default fitTablePinPadFormMeta;